import type { SlideBlock } from '@ps/web-martech-cms-types/Carousel';
import React from 'react';

import CarouselSlider from '../CarouselSlider';

import DefaultCarouselItem from './DefaultCarouselItem';

interface Props {
  autoRotate: boolean;
  slides: SlideBlock[];
  slideSpeed: number;
  withHeading: boolean;
}

const minNumberOfSlides = 3;

const DefaultCarousel: React.FC<Props> = ({ autoRotate, slides, slideSpeed, withHeading }) => {
  if (slides.length < minNumberOfSlides) {
    return null;
  }

  return (
    <CarouselSlider
      autoRotate={autoRotate}
      className="center"
      responsive={[
        {
          breakpoint: 725,
          settings: {
            slidesToShow: 1
          }
        }
      ]}
      slideSpeed={slideSpeed}
      withHeading={withHeading}
    >
      {slides.map(({ slide }, key) => (
        <DefaultCarouselItem key={key} slide={slide} />
      ))}
      {slides.length === minNumberOfSlides &&
        slides.map(({ slide }, key) => <DefaultCarouselItem key={key} slide={slide} />)}
    </CarouselSlider>
  );
};

export default DefaultCarousel;
